export default "__VITE_ASSET__BQduxODF__"